module Meevo.Plugins.Register {
    export class MeevoRegisterContext implements angular.IDirective {
        restrict = "A";
        scope = { register: "=" };
        templateUrl = "app/plugins/register/directives/registerContext.template.html";

        link = (scope: any, element: angular.IAugmentedJQuery, attributes: any) => {
            scope.RegisterSectionTypeEnum = RegisterSectionTypeEnum;

            scope.loadContextData = function () {
                scope.section = scope.register.context.selectedSection;
            }

            scope.save = (isValid) => {
                angular.forEach(scope["registerSectionForm"], function (value, key) {
                    if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue'))
                        scope["registerSectionForm"][key].$dirty = true;
                });
                scope.register.context.selectedSection.save(isValid);
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoRegisterContext();
            };

            return directive;
        }
    }

    angular.module("meevo.plugins.register")
        .directive("meevoRegisterContext", MeevoRegisterContext.factory());
}